import { makeStyles } from 'tss-react/mui';

const SEPARATOR_THICKNESS = 1;
const SEPARATOR_FADE = '12%';
const SEPARATOR_HIT_AREA = 5;

interface ResizeSeparatorStylesParams {
  isVertical: boolean;
}

export const useResizeSeparatorStyles = makeStyles<ResizeSeparatorStylesParams>()(
  (theme, { isVertical }) => {
    const fadeDirection = isVertical ? 'to bottom' : 'to right';
    const line = theme.palette.action.active;
    const opaque = theme.palette.common.black;

    return {
      separator: {
        position: 'relative',
        zIndex: 1,
        width: isVertical ? SEPARATOR_THICKNESS : undefined,
        height: isVertical ? undefined : SEPARATOR_THICKNESS,
        outline: 'none',
        opacity: 0,
        transition: theme.transitions.create('opacity', {
          duration: theme.transitions.duration.shortest,
        }),
        '&::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          pointerEvents: 'none',
          backgroundColor: line,
          maskImage: `linear-gradient(${fadeDirection}, transparent, ${opaque} ${SEPARATOR_FADE}, ${opaque} calc(100% - ${SEPARATOR_FADE}), transparent)`,
        },
        '&[data-separator="hover"], &[data-separator="active"], &:hover, &:focus-visible': {
          opacity: 1,
        },
        '&[data-separator="disabled"]': {
          pointerEvents: 'none',
        },
      },
      hitArea: {
        position: 'absolute',
        top: isVertical ? 0 : -SEPARATOR_HIT_AREA,
        bottom: isVertical ? 0 : -SEPARATOR_HIT_AREA,
        left: isVertical ? -SEPARATOR_HIT_AREA : 0,
        right: isVertical ? -SEPARATOR_HIT_AREA : 0,
      },
    };
  },
);
